import MenuItem from '@mui/material/MenuItem'
import { IAimStatus } from '@common/interfaces/user'
import styles from './AimStatusMenuItem.module.scss'

interface IProps {
  status: IAimStatus | null
  className?: string
  onClick: () => void
}

/** The profile-menu row that opens AimStatusModal, showing the current status once set. */
const AimStatusMenuItem = ({ status, className, onClick }: IProps) => (
  <MenuItem className={className} onClick={onClick}>
    <span className={styles.statusIcon} aria-hidden>
      {status?.emoji || '💬'}
    </span>
    <span className={styles.statusLabel}>{status?.text || 'Set a status'}</span>
  </MenuItem>
)

export default AimStatusMenuItem
